import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const loadCustomer = createAction('[Customers] Load Customer', props<{ groupId: string }>());

export const loadCustomerSuccess = createAction('[Customers] Load Customer Success', props<{ group: Group }>());

export const loadCustomerFailure = createAction('[Customers] Load Customer Failure', props<{ error: any }>());
